import type { ContentNode } from "@/components/ui/readable-content";
import { PROMPT_EXAMPLE_CONTEXT } from "./promptExampleContext";
import { renderPromptTemplate } from "./renderPromptTemplate";

export function buildRenderedPromptPreview(
  systemTemplate: string,
  userTemplate: string,
  context: Record<string, string> = PROMPT_EXAMPLE_CONTEXT
): { system: string; user: string; content: ContentNode } {
  const system = renderPromptTemplate(systemTemplate, context);
  const user = renderPromptTemplate(userTemplate, context);

  const content: ContentNode = {
    type: "section",
    title: "Rendered with example data",
    blocks: [
      {
        type: "section",
        title: "System prompt",
        blocks: [{ type: "markdown", text: system }],
      },
      {
        type: "section",
        title: "User prompt",
        blocks: [{ type: "markdown", text: user }],
      },
    ],
  };

  return { system, user, content };
}
